import { Button } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Flex, Image, Heading } from '@aws-amplify/ui-react';
import {
    Table,
    TableCell,
    TableBody,
    TableHead,
    TableRow,
} from '@aws-amplify/ui-react';
import {
  useNavigate,
} from "react-router-dom";


const Home = ({ amplifyConfig }) => {
    const navigate = useNavigate()

    return (
        <div>
            <br />
            <Flex direction="column"
                justifyContent="center"
                alignItems="center">
                <Image
                    alt="Engage Translate Logo"
                    src="/engage-translate-logo.png"
                    width="20%"
                />
                <Heading level={3}>
                    {amplifyConfig.name} Application
                </Heading>

                <Heading level={5}>
                    Cognito Configurations
                </Heading>
                <Table
                    size="small"
                    caption=""
                    highlightOnHover={true}
                    variation="bordered"
                    width={600}>
                    <TableHead>
                        <TableRow>
                            <TableCell as="th">Name</TableCell>
                            <TableCell as="th">Value</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Client Name</TableCell>
                            <TableCell>{amplifyConfig?.name}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Identifier</TableCell>
                            <TableCell>{amplifyConfig?.identifier}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Region</TableCell>
                            <TableCell>{amplifyConfig?.region}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>User Pool ID</TableCell>
                            <TableCell>{amplifyConfig?.userPoolId}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Cognito Domain</TableCell>
                            <TableCell>{amplifyConfig?.cognitoDomain}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Client ID</TableCell>
                            <TableCell>{amplifyConfig?.clientID}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Scopes</TableCell>
                            <TableCell>{amplifyConfig.scopes.join(', ')}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Response Type</TableCell>
                            <TableCell>{amplifyConfig.responseType}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>IDP Provider Name</TableCell>
                            <TableCell>{amplifyConfig.idpProviderName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Sign In Redirect URI</TableCell>
                            <TableCell>{amplifyConfig.signInRedirectURI.join(', ')}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Sign Out Redirect URI</TableCell>
                            <TableCell>{amplifyConfig.signOutRedirectURI.join(', ')}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Button variation="primary" onClick={()=>{navigate('/login')}}>Sign In with Organisation</Button>
            </Flex>
        </div>
    )
}

export default Home